
import { defineComponent, onBeforeMount, reactive } from 'vue'

// Components
import Modal from '@/common/components/UI/Modal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// Realisations
import { companies } from '@/core/realisations/companies.realisation'

// Validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// Composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        Modal,
        FileReader,
        Checkbox,
    },
    emits: ['cancel', 'imported'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            files: [] as File[],
            is_activated: false,
        })

        const state_form$ = useVuelidate({ files: { required } }, state)

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const importCompanies = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid || state.is_loading) return

            try {
                state.is_loading = true

                const form_data = new FormData()
                
                form_data.append('file', state.files[0])

                if (state.is_activated) {
                    form_data.append('isActivated', '1')
                } else {
                    form_data.append('isActivated', '0')
                }

                await companies.importCompanies(form_data)

                notifications.notify({ type: 'success', title: 'Контрагенты импортированы' })

                emit('imported')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При импортировании контрагентоов произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            emitCancel,
            importCompanies,
        }
    }
})
